import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const loadInvitation = actionCreator(
  actionTypes.ACCEPT_INVITATION_LOAD,
  ({ invitationToken }) => ({
    invitationToken
  })
)

export const loadInvitationSucceeded = actionCreator(
  actionTypes.ACCEPT_INVITATION_LOAD_SUCCEEDED,
  ({ name, email }) => ({
    name,
    email
  })
)

export const loadInvitationFailed = actionCreator(
  actionTypes.ACCEPT_INVITATION_LOAD_FAILED
)

export const acceptInvitation = actionCreator(
  actionTypes.ACCEPT_INVITATION_CONFIRM,
  ({ invitationToken, password, passwordConfirmation, recaptchaResponse }) => ({
    invitationToken,
    password,
    passwordConfirmation,
    recaptchaResponse
  })
)

export const acceptInvitationSucceeded = actionCreator(
  actionTypes.ACCEPT_INVITATION_CONFIRM_SUCCEEDED,
  ({ isUserActive }) => ({ isUserActive })
)

export const acceptInvitationFailed = actionCreator(
  actionTypes.ACCEPT_INVITATION_CONFIRM_FAILED,
  ({ confirmationError }) => ({ confirmationError })
)
